import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type ApiComponent from '../api-component.vue'

import type { FormProps } from 'ant-design-vue'

import type { IJsonXmlItem } from './'

export type IMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

export type IValueType =
  | 'string'
  | 'integer'
  | 'boolean'
  | 'number'
  | 'array'
  | null
  | any

export interface IParam {
  required?: boolean
  name?: string
  value?: string
  type?: IValueType
  static?: boolean
  contentType?: string
  description?: string
  chineseName?: string
  children?: IParam[]
  [key: string]: any
}

export const DEFAULT_METHOD = 'GET'

export const requestList = [
  {
    key: 'params',
    name: '请求参数'
  },
  {
    key: 'body',
    name: '请求报文体'
  },
  {
    key: 'headers',
    name: '请求头'
  }
]

export const bodyList = [
  {
    key: 'none',
    name: 'none'
  },
  {
    key: 'form-data',
    name: 'form-data'
  },
  {
    key: 'x-www-form-urlencoded',
    name: 'x-www-form-urlencoded'
  },
  {
    key: 'json',
    name: 'json'
  },
  {
    key: 'xml',
    name: 'xml'
  },
  {
    key: 'raw',
    name: 'raw'
  }
]

export interface IApiParams {
  url?: string
  method?: IMethod
  requestParams?: IParam[]
  headerParams?: IParam[]
  bodyParams?: Record<string, any>
}

// export const httpModel = buildProps({
//   url: {
//     type: String,
//     default: ''
//   },
//   method: {
//     type: definePropType<IMethod>(String),
//     default: DEFAULT_METHOD
//   },
//   requestParams: {
//     type: definePropType<IParam[]>(Array),
//     default: () => [] as IParam[]
//   },
//   headerParams: {
//     type: definePropType<IParam[]>(Array),
//     default: () => [] as IParam[]
//   },
//   bodyParams: {
//     type: Object,
//     default: () => ({
//       none: null,
//       'form-data': [],
//       json: [],
//       xml: [],
//       raw: '',
//       'x-www-form-urlencoded': []
//     })
//   }
// } as const)

// export type HttpModel = ExtractPropTypes<typeof httpModel>
export type BodyParams = {
  // none: null
  // 'form-data': IParam[]
  // json: IJsonXmlItem[]
  // xml: IJsonXmlItem[]
  // raw: string
  // 'x-www-form-urlencoded': IParam[]
  type: 'none' | 'form-data' | 'json' | 'xml' | 'raw' | 'x-www-form-urlencoded'
  parameters: IParam[]
  jsonSchema: IJsonXmlItem[]
  description: string
}

export type HttpModel = {
  url: string
  method: IMethod
  requestParams: IParam[]
  headerParams: IParam[]
  bodyParams: BodyParams
}

export const apiComponentProps = buildProps({
  value: {
    type: definePropType<HttpModel>(Object),
    default: () => ({
      url: '',
      method: DEFAULT_METHOD,
      requestParams: [],
      headerParams: [],
      bodyParams: {
        type: 'none',
        parameters: [],
        jsonSchema: [],
        description: ''
      }
    })
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isValid: {
    type: Boolean,
    default: false
  },
  rules: {
    type: definePropType<FormProps['rules']>(Object),
    default: () => ({
      url: [
        {
          required: true,
          trigger: 'blur',
          message: '请输入url'
        },
        {
          trigger: 'change',
          pattern:
            /^(http|https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/,
          message: '输入url格式错误'
        }
      ]
    })
  }
} as const)

export const apiComponentEmits = {
  change: (value: HttpModel) => !!value,
  'update:value': (value: HttpModel) => !!value
}
// props
export type ApiComponentProps = ExtractPropTypes<typeof apiComponentProps>

// emits
export type ApiComponentEmits = typeof apiComponentEmits

// instance
export type ApiComponentInstance = InstanceType<typeof ApiComponent>
